export default "__VITE_ASSET__DBzHQU7K__"